<template>
  <SysDialog v-model="dialog" titulo="Exportação Api Acal" ocultar-acoes>
    <template #ativador>
      <v-btn icon @click="dialog = !dialog">
        <v-icon :size="16">mdi-information-outline</v-icon>
      </v-btn>
    </template>

    <CorpoDialog :msg_error="msg_error" :id_pedido_gerado="id_pedido_gerado" />
  </SysDialog>
</template>

<script setup>
import { ref, watch } from "vue";
import Api from "@/api/api.js";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import CorpoDialog from "./CorpoDialog.vue";

const id_pedido_gerado = ref(null);
const msg_error = ref('');
const props = defineProps({ id_pedido: Number });
const dialog = ref(false);

watch(() => dialog.value, buscarIdPedidoGeradoComBaseNoIdPedidoSystock);

function buscarIdPedidoGeradoComBaseNoIdPedidoSystock() {
  Api.get('drp/pedidos/exportacoes/gemco/pedido-gerado', { params: { idpedido: props.id_pedido }})
    .then(resp => {
      const { pedido_gerado } = resp.data;
      if (pedido_gerado) {
        const { numeroPedido } = JSON.parse(pedido_gerado.exportacao);
        id_pedido_gerado.value = numeroPedido;
      } else {
        msg_error.value = 'Não possui resgistro.'
      }
    });
}
</script>
